import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import islands from '@constants/islands'
import daysOfWeek from '@constants/weekdys'

export default class __SERVICE_NAME__ extends React.Component {
  resource = '/youth_organizations'
  form_key = 'youth_organization'
  defaults = {
    shareholders_list: [
      {
        position: 'President',
        first_name: '',
        last_name: '',
        email: ''
      },
      {
        position: 'Vice President',
        first_name: '',
        last_name: '',
        email: ''
      },
      {
        position: 'Secretary',
        first_name: '',
        last_name: '',
        email: ''
      },
      {
        position: 'Treasurer',
        first_name: '',
        last_name: '',
        email: ''
      },
    ]
  }

  // Delete lines as needed
  free          = true
  skip_location = true
  hide_buttons  = false
  custom_actions = []

  foremost = null

  validate = form => {
    const serviceCategoryList = form.service_category_list.filter(x => x != 'Other')
    if (form.service_category_list.includes('Other')) {
      const otherList = form.service_category_other_list.map(x => x.other_category)
      const mergedList = serviceCategoryList.concat(otherList);
      // const objectList = mergedList.map(x => ({ issue: x }));
      // console.log(disputeList);
      // console.log(otherList);
      // console.log(mergedList);
      // console.log(objectList);

      return { service_category_list: mergedList }
    } else {
      return { service_category_list: serviceCategoryList }
    }
  }

  fields = form => [
    '::Personal Details',
    {
      name: 'contact_person_title',
    },

    '::Organization Details',
    {
      name: 'organization_name',
      label: 'Name of Organization',
    },
    {
      name: 'organization_type',
      label: 'Type of Organization',
      options: [
        'Religious',
        'Private',
        'Government',
        'Community',
        'Non-profit Organization/Non-government Organization'
      ],
    },
    {
      name: 'organization_start_date',
      type: 'date',
      label: 'Date of Establishment',
      showYearDropdown: true,
    },

    '::Organization Heads (Executive Team)',
    {
      name: 'shareholders_list',
      label: 'Executive Team',
      min: 4,
      max: 4,
      fields: [
        {
          name: 'position',
          label: 'Position',
          options: [
            'President',
            'Vice President',
            'Secretary',
            'Treasurer',
          ]
        },
        {
          name: 'first_name',
          label: 'First Name',
        },
        {
          name: 'middle_name',
          label: 'Middle Name',
          required: false,
        },
        {
          name: 'last_name',
          label: 'Last Name',
        },
        {
          name: 'email',
          type: 'email'
        },
        {
          name: 'phone_number',
          type: 'phone',
          required: false,
        },
      ]
    },
    {
      name: 'youth_programs_list',
      label: 'Youth Related Programs',
      fields: [
        {
          name: 'program_name',
          label: 'Program Name',
        },
        {
          name: 'program_description',
          label: 'Program Description',
          required: false,
        },
      ]
    },
    {
      name: 'office_locations_list',
      label: 'Office Location(s)',
      fields: [
        {
          name: 'island',
          label: 'Island',
          options: islands,
        },
        {
          name: 'office_address',
          label: 'Office Address',
        },
        {
          name: 'office_phone_number',
          type: 'phone'
        },
        {
          name: 'office_email',
          type: 'email'
        },
      ]
    },

    '::Social Media',
    {
      name: 'current_website',
      label: 'Do you have a current website/social media pages?',
      type: 'select:bool'
    },
    {
      name: 'web_address',
      label: 'Website URL',
      hint: 'Please provide the URL, eg: https://www.example.com',
      hide: !form.current_website,
      required: false,
    },
    {
      name: 'social_media_list',
      label: 'Please provide them',
      fields: [
        { 
          name: 'social_media',
          label: 'Social Media Platform',
          options: [
            'Facebook',
            'Instagram',
            'Twitter',
            'LinkedIn',
            'Snapchat',
            'YouTube',
            'TikTok',
          ]
        },
        {
          name: 'account_name',
          label: 'Account Name',
          hint: 'Please provide the account name associated with social media page'
        },
      ],
      hide: !form.current_website
    },

    {
      name: 'youth_coordinators_list',
      label: 'Youth Program Coordinator(s)',
      fields: [
        {
          name: 'first_name',
          label: 'First Name',
        },
        {
          name: 'middle_name',
          label: 'Middle Name',
          required: false,
        },
        {
          name: 'last_name',
          label: 'Last Name',
        },
        {
          name: 'email',
          type: 'email',
          required: false,
        },
        {
          name: 'phone_number',
          type: 'phone',
          required: false,
        },
      ]
    },
    {
      name: 'is_affiliated',
      label: 'Is this organization affiliated with any other organizations?',
      type: 'select:bool',
    },
    {
      name: 'affiliated_details',
      label: 'Please specify affiliated organization(s)',
      hide: !form.is_affiliated == 'Yes',
    },
    {
      name: 'service_category_list',
      label: 'What category of service do you provide?',
      multi: true,
      options: [
        'Performing Arts/Cultural',
        'Technical/Educational',
        'Character/Social Development',
        'Spiritual development',
        'Community Service',
        'Environmental',
        'Bands',
        'Other'
      ],
    },
    {
      name: 'service_category_other_list',
      label: 'Please specify other categories of service',
      fields: [
        {
          name: 'other_category',
          label: 'Other Category',
        },
      ],
      view: false,
      hide: !form.service_category_list?.includes('Other'),
    },
    {
      name: 'has_associated_fees',
      label: 'Are there any fees associated with this service that you offer?',
      type: 'select:bool',
    },
    {
      name: 'associated_fees_details',
      label: 'Please specify the fees associated with this service',
      hide: !form.has_associated_fees == 'Yes',
    },
    {
      name: 'progam_purpose',
      label: 'What is the general purpose of this youth program?',
    },
    {
      name:'target_population',
      label: 'What is your target population?',
      options: [
        'Under 12 years (primary)',
        '16-25 years', 
        'Females only', 
        'Males only', 
        'Males and Females',
        '12-18 years (high school)',
        'All ages',
        'At-Risk/Marginalized youth'
      ]
    },
    {
      name: 'meeting_frequency_list',
      label: 'Meeting Days',
      multi: true,
      options: daysOfWeek,
      format: val => val.join(', ')
    },
    {
      name: 'meeting_locations_list',
      label: 'Meeting Location(s)',
      fields: [
        'description',
        'address'
      ]
    },

    {
      name: 'number_of_active_members',
      label: 'Number of Active Members',
      type: 'integer',
    },
    {
      name: 'eligibility_requirements_list',
      label: 'Member eligibility requirements',
      columns: ['requirement'],
      format: v => v.requirement,
    },
    {
      name: 'services_provided_list',
      label: 'Specific services provided',
      columns: ['service'],
      format: v => v.service,
    },
    {
      name: 'group_activies_list',
      label: 'Describe routine activities of a regular meeting',
      columns: ['activity'],
      format: v => v.activity,
    },
    {
      name: 'training_completed',
      label: `Have any of your members completed a youth worker training program
        or have formal education in youth work/counseling?`,
      type: 'select:bool',
    },
    {
      name: 'trained_youth_workers_list',
      label: 'List trained youth workers and note the qualification',
      fields: [
        { name: 'first_name', label: 'First Name' },
        { name: 'middle_name', label: 'Middle Name', required: false },
        { name: 'last_name', label: 'Last Name' },
        { name: 'qualification', label: 'Qualification' },
        { name: 'year_of_qualification', label: 'Year of Qualification', type: 'date', showYearDropdown: true },
      ],
      hide: !form.training_completed,
    },

    '::Uploads',
    {
      name: 'organization_profile_upload',
      type: 'file:pdf',
      label: `Organiztion's Aims & Objectives`,
      required: false,
    },
    {
      name: 'proposal_upload',
      type: 'file:pdf',
      label: 'Business Proposal',
      required: false,
    },
  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
